var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('img',{attrs:{"src":require("../assets/icon/error.svg"),"alt":""}}),_c('p',[_vm._v("错误: "+_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }